import { render } from "./InventoryMenu.vue?vue&type=template&id=f07ce6c4"
import script from "./InventoryMenu.vue?vue&type=script&lang=js"
export * from "./InventoryMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__